import React from 'react';
import PropTypes from 'prop-types';

import Button from 'rebook/apps/base/components/Button';


const BookReadButton = ({ book, children, isReaderUnavailable, extraClassName, GACategory, link }) => {
  const defaultLink = isReaderUnavailable ? '/payments/' : book.getReaderUrl();
  return (
    <Button
      url={link ? link : defaultLink}
      extraClassName={extraClassName}
      handleClick={() => {
        yaMetrikaReachGoal('BookOpen');
        ga('send', 'event', GACategory, 'PushButton', 'Read');
      }}>
      {children}
    </Button>
  );
};

BookReadButton.propTypes = {
  book: PropTypes.object.isRequired,
  extraClassName: PropTypes.string,
  GACategory: PropTypes.string,
};

export default BookReadButton;
